module.exports = __webpack_public_path__ + "static/media/photo31.f195f028.jpg";